export default "__VITE_ASSET__f6d170b1__"